module.exports = __webpack_public_path__ + "img/f2873549d596f744336b996d9b089d46.7fffb52a.jpg";